import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/useHostPropertyCitiesQuery.ts
var r = () => t({
	queryKey: e.list({ scope: "host-cities" }),
	queryFn: () => n.getHostPropertyCities()
});
//#endregion
export { r as useHostPropertyCitiesQuery };
